import { render, staticRenderFns } from "./returnPro.vue?vue&type=template&id=33fc3fed&scoped=true&"
import script from "./returnPro.vue?vue&type=script&lang=js&"
export * from "./returnPro.vue?vue&type=script&lang=js&"
import style0 from "./returnPro.vue?vue&type=style&index=0&id=33fc3fed&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fc3fed",
  null
  
)

export default component.exports